import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		icon: {
			width: 24,
			height: 24,
			marginRight: 10,
		},
	} satisfies Record<string, CSSObject>);
};
